import { useFormik } from 'formik';
import React from 'react';
import { Redirect } from 'react-router-dom';

import { useAppSelector } from '@app/redux/hooks';
import { getMFAPreconditionData } from '@app/redux/mfa/mfa.selectors';
import RoutePaths from '@app/routes/paths';
import useGenerateRoutePath from '@app/routes/paths/useGenerateRoutePath';

import TOTPForm from '@components/forms/verifyTOTP';
import authAppTOTPValidationScheme from '@components/forms/verifyTOTP/validationScheme';

import { AuthAppTOTPFormValues } from '@pages/Verification/MFASetupPage/components/EnableTOTP2FA/hooks/useAuthAppTOTPForm';
import MFA_METHODS_ENUM from '@pages/Verification/MFASetupPage/enums/MFA_METHODS.enum';

import { use2FALogin } from '../../use2FALogin';

const TOTP2FA = ({ onDecline }: { onDecline?: () => void }) => {
	const mfaPreconditionData = useAppSelector(getMFAPreconditionData);
	const { login } = use2FALogin({ method: MFA_METHODS_ENUM.TOTP });
	const generateRoutePath = useGenerateRoutePath();
	const formik = useFormik<AuthAppTOTPFormValues>({
		validationSchema: authAppTOTPValidationScheme,
		initialValues: { code: '' },
		onSubmit: login,
	});

	return mfaPreconditionData ? (
		<TOTPForm<AuthAppTOTPFormValues> title="Enter two factor verification code" onDecline={onDecline} formik={formik} />
	) : (
		<Redirect to={generateRoutePath(RoutePaths.AUTH.LOGIN)} />
	);
};

export default TOTP2FA;
